export default function init() {
    jQuery(document).ready(function ($) {
        //Mob-menu
        $('#header-burger').on('click', function (e) {
            $(this).toggleClass('active');
            $('#mobMenu').toggleClass('active');
            $('body').toggleClass('overflow-h');
        });
        $('.close-mob-menu-js').on('click', function (e) {
            $('body').removeClass('overflow-h');
            $('#header-burger').removeClass('active');
            $('#mobMenu').removeClass('active');
        });

        //scroll-header-menu
        var scrollPos = 0;
        $(document).scroll(function () {
            if (400 < $(document).scrollTop()) {
                $('#header').addClass('h-fixed');
            } else {
                $('#header').removeClass('h-fixed');
            }

            var st = $(this).scrollTop();
            if (st < scrollPos) {
                $('#header').removeClass('active');
            } else {
                $('#header').addClass('active');
            }
            scrollPos = st;
            if (scrollPos <= 200) {
                $('#header').removeClass('active');
            }
        });

        //============================= accordeon
        $('.accordeon-tab-js').on('click', function () {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).find('.accordeon-content-js').hide('300');
            } else {
                $('.accordeon-tab-js').removeClass('active');
                $(this).addClass('active');
                $('.accordeon-content-js').slideUp(200);
                $(this).find('.accordeon-content-js').toggle('blind');
            }
        });
        //============================= accordeon end

        $('.rarity-img-slider-js').slick({
            arrows: false,
            dots: false,
            slidesToShow: 1,
            autoplay: true,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            adaptiveHeight: true,
        });
        $('.dog-slider-js').slick({
            arrows: false,
            dots: false,
            slidesToShow: 1,
            autoplay: true,
            speed: 500,
            fade: true,
            cssEase: 'linear',
        });
    });
}
